<template>
  <el-drawer
    custom-class="drawer-wrapper"
    v-bind="$attrs"
    :wrapperClosable="wrapperClosable"
    :visible.sync="showModal"
    :direction="direction"
    :destroy-on-close="destroyOnClose"
  >
    <span slot="title" v-if="$slots.title">
      <slot name="title"></slot>
    </span>

    <div class="drawer-content">
      <slot></slot>
    </div>

    <div class="drawer-footer">
      <el-button style="margin-right: 8px" @click="onDrawerClose"> 取消 </el-button>
      <el-button type="primary" :loading="loading" @click="onDrawerConfirm">确认</el-button>
    </div>
  </el-drawer>
</template>

<script setup>
import { ref, computed } from 'vue'

// eslint-disable-next-line
const props = defineProps({
  value: Boolean,
  wrapperClosable: {
    type: Boolean,
    default: false
  },
  direction: {
    type: String,
    default: 'rtl'
  },
  loading: {
    type: Boolean
  },
  destroyOnClose: {
    type: Boolean,
    default: false
  },
  beforeClose: Function
})
// eslint-disable-next-line
const emit = defineEmits(['input', 'close', 'confirm'])
const showModal = computed({
  get() {
    return props.value
  },
  set(val) {
    emit('input', val)
  }
})

function onDrawerConfirm() {
  if (props.beforeClose && typeof props.beforeClose === 'function') {
    props.beforeClose(() => {
      emit('confirm')
    })
  } else {
    emit('confirm')
  }
}

function onDrawerClose() {
  showModal.value = false
  emit('close')
}
</script>

<style lang="scss" scoped>
::v-deep .drawer-wrapper {
  .el-drawer__header {
    font-size: 20px;
    color: #333;
    border-bottom: 1px solid #dddddd;
    padding-bottom: 20px;
    margin-bottom: 0;
  }

  .el-drawer__body {
    display: flex;
    flex-direction: column;
    .drawer-content {
      overflow: auto;
      flex: 1;
    }
    .drawer-footer {
      border-top: 1px solid #dddddd;
      padding: 20px;
      text-align: right;
    }
  }
}
</style>
